// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar_sidebar__go0QL","folders":"Sidebar_folders__jVAzx","folder":"Sidebar_folder__8-wNY","sideNav":"Sidebar_sideNav__z655R","navItem":"Sidebar_navItem__Vr8Yw"};